import { ConversionsOTLineGraph } from '../../organisms/ConversionsOTLineGraph';
import { MetricsByChannelTable } from '../../organisms/MetricsByChannelTable';
import { MediaMatrixBox } from '../../organisms/MediaMatrixBox';
import { MetricsByChannelBarGraph } from '../../organisms/MetricsByChannelBarGraph';
import { CPAOTBox } from '../../organisms/CPAOTBox';
import { SpendOTBox } from '../../organisms/SpendOTBox';
import { TotalConversionsOTBox } from '../../organisms/TotalConversionsOTBox';
import { useKpiMetricLabels } from 'src/hooks/useKpiMetricLabels';

export const Overview: React.FC = () => {
  const { metricLabel } = useKpiMetricLabels();
  return (
    <>
      <CPAOTBox />
      <SpendOTBox />
      <TotalConversionsOTBox />
      <ConversionsOTLineGraph
        minH={400}
        title={`${metricLabel} over time`}
        colSpan={12}
      />
      <MetricsByChannelBarGraph
        minH={400}
        title="Metrics overview"
        colSpan={12}
      />
      <MetricsByChannelTable title="Media Coverage" colSpan={12} />
      <MediaMatrixBox minH={600} title="Media matrix" colSpan={12} />
    </>
  );
};
